import { ExtendedAddress } from '@porterin/booking-flow/src/order-review/domain/entities/ExtendedAddress';
import { getExtendedAddressFromLatLng } from '@porterin/booking-flow/src/order-review/view/helpers/GeoCodeHelper';
import { AutoDetectLocationErrorCmp } from '@porterin/component-library/src/location-accuracy/components/AutoDetectLocationErrorCmp';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import {
  CONFIG,
  GaEventsLocationAccuracy,
  selectLocationIcon,
} from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import { handleGeolocationError } from '@porterin/component-library/src/location-accuracy/utils/LocationAccuracyHelpers';
import {
  publishEvent,
  publishEventParameter,
} from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import {
  getScreenName,
  isDesktop,
} from '@porterin/lead-flow/src/components/FareEstimateHelper';
import Image from 'next/image';
import React, { useState } from 'react';

export const AutoDetectLocationCmp: React.FC = () => {
  const { selectLocation, state } = useLocation();
  const [error, setError] = useState<string | null>(null);
  const handleGetLocation = () => {
    publishEventParameter(
      state.waypoint === 'Pickup'
        ? GaEventsLocationAccuracy.useCurrentLocationClick
        : GaEventsLocationAccuracy.dropLocateClicked,
      {
        category: 'Location Accuracy',
        device: isDesktop() ? 'Desktop' : 'mobile',
        screen_name: getScreenName(),
      },
    );
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async position => {
        try {
          const { latitude, longitude } = position.coords;
          const result: ExtendedAddress = await getExtendedAddressFromLatLng({
            lat: latitude,
            lng: longitude,
          });

          publishEvent({
            category: 'Location Accuracy',
            action: GaEventsLocationAccuracy.allowCurrentLocationClick,
          });
          selectLocation(result);
          setError(null);
        } catch (error) {
          setError('Failed to fetch address from location');
        }
      },
      err => {
        publishEvent({
          category: 'Location Accuracy',
          action: GaEventsLocationAccuracy.dontAllowCurrentLocationClick,
        });
        handleGeolocationError(err, setError);
      },
      { maximumAge: CONFIG.locationAccuracyMaxAge },
    );
  };

  return (
    <>
      <button
        className="flex items-center justify-center bg-white pt-8 px-8"
        data-testid="detect-location-btn"
        id="detect-location-btn"
        onClick={handleGetLocation}
      >
        <Image
          src={selectLocationIcon}
          alt="Select Location"
          width={20}
          height={20}
          className="mr-3"
        />
        <span className="text-[1.4rem]">Use Current Location</span>
      </button>
      {error && <AutoDetectLocationErrorCmp message={error} />}
    </>
  );
};
